import { initialChat } from '../constants/initialStates';

export const normalizeChats = (state, conversations) =>
  conversations.reduce(
    (acc, conversation) => ({
      byId: {
        ...acc.byId,
        [conversation.chatId]: {
          ...initialChat,
          ...conversation,
        },
      },
      allIds: acc.allIds.includes(conversation.chatId)
        ? acc.allIds
        : [...acc.allIds, conversation.chatId],
      conversations: [conversation.chatId, ...acc.conversations],
    }),
    { byId: state.chats.byId, allIds: state.chats.allIds, conversations: [] },
  );
